export interface DoseSiteSummaryType {
  id: string;
  isShown: boolean;
  isSelected: boolean;
  emrType: string;
  course: string;
  site: string;
  technique: string;
  status: string;
  statusReason: string;
  treatmentStartDate: string;
  treatmentEndDate: string;
  treatmentLatestDate: string;
  prescribedDosage: number;
  prescribedFractionDose: number;
  deliveredDosage: number;
  deliveredFractionDose: number;
  group: string;
}

export type FormStateType = {
  reviewDate: string | null;
  roPlan: string;
  doseSiteSummaries: DoseSiteSummaryType[];
  toxicityType: string;
  toxicityCategories: string[];
  additionalSummaryReviewNotes: string;
  practitioner?: string;
  otherToxicityDetails: string;
};

export interface TreatmentReviewType {
  id: string;
  group: {
    id: string;
  };
  reviewDate: string;
  roPlan: string;
  toxicityType: string;
  toxicityCategories: string[];
  otherToxicityDetails: string;
  additionalSummaryReviewNotes: string;
  dosesitesummarySet: DoseSiteSummaryType[];
  status: string;
  submittedAt: string;
  lastSubmittedAt: string | null;
  currentChanges: boolean;
  doseSiteSummariesLastSyncedAt: string | null;
}

export enum BannerType {
  DRAFT = 'draft',
  UNSUBMITTED = 'unsubmitted',
  SUBMITTED = 'submitted',
  NONE = 'none',
}
